import { render } from "./EDMPage.vue?vue&type=template&id=aa5cc946&scoped=true"
const script = {}

import "./EDMPage.vue?vue&type=style&index=0&id=aa5cc946&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa5cc946"]])

export default __exports__